import { useAllAccountSummary, useCreditAccounts } from '../../../helpers/syfApiQueries';
import isMockDataEnabled from '../../../helpers/isMockDataEnabled';
import { sandboxMockAccounts } from '../../../const/mockData/accountSummary';
import isPlatformPeaks from '../../../helpers/isPlatformPeaks';
import { AccountIdType } from '../../../const/alertsConfig';
var useAccountsInfoData = function (config, platForm, accountSummaryKeys) {
    if (accountSummaryKeys === void 0) { accountSummaryKeys = []; }
    var isMockData = isMockDataEnabled();
    var ispeaks = isPlatformPeaks(platForm);
    var isAccountApiError = new URLSearchParams(window.location.search).has('accountsError');
    var _a = useCreditAccounts(config, { enabled: !ispeaks }), _b = _a.data, _c = _b === void 0 ? {} : _b, _d = _c.accounts, accounts = _d === void 0 ? [] : _d, isLoading = _a.isLoading, isFetching = _a.isFetching, isError = _a.isError;
    var peaksSummaryKeys = accountSummaryKeys;
    var defaultSummaryKeys = accounts === null || accounts === void 0 ? void 0 : accounts.map(function (account) {
        return {
            accountId: account === null || account === void 0 ? void 0 : account.info['cipher.accountId'],
            accountIdType: AccountIdType.GUID
        };
    });
    var accountSummaryCacheKeys = ispeaks
        ? peaksSummaryKeys
        : defaultSummaryKeys;
    var allAccountSummaryQuery = useAllAccountSummary(config, accountSummaryCacheKeys);
    var accountsData = allAccountSummaryQuery.map(function (result) { return result.data; });
    var isAllAccountSummaryLoading = allAccountSummaryQuery.some(function (queryData) { return queryData.isLoading; });
    var isCreditAccountLoading = isLoading && isFetching;
    var isAccountsDataLoading = isAllAccountSummaryLoading || isCreditAccountLoading;
    if (isMockData) {
        if (isAccountApiError) {
            return {
                data: undefined,
                isLoading: false,
                isError: true
            };
        }
        return {
            data: sandboxMockAccounts,
            isLoading: false,
            isError: false
        };
    }
    return {
        data: accountsData,
        isLoading: isAccountsDataLoading,
        isError: isError
    };
};
export default useAccountsInfoData;
